import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-question-damage-image-top',
    templateUrl: './question-damage-image-top.component.html',
    styleUrls: ['./question-damage-image-top.component.scss'],
    standalone: false
})
export class QuestionDamageImageTopComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
